const handleDeleteGroupModalEquipService = {
  confirm: 'Do you really want to delete the section',
  title: 'DELETE CHECKLIST SECTION'
};

export default handleDeleteGroupModalEquipService;
